import QueryString from 'qs';
import { getV3, internalGet, internalPut, unwrapListEnvelope } from './';

// Detail and the other admin flows live on /internal: the edit tabs
// round-trip fields (adress, city, markets, regions, fluxes…) that the
// partner-facing v3 DTO deliberately drops.
export const getOrganization = ({ id, filters = {} }) => {
  if (isNaN(id)) {
    return Promise.resolve(null);
  }
  return internalGet(
    `organizations/${id}?${QueryString.stringify({ ...filters })}`,
  );
};

// v1 query params -> the v3 DTO (isPartner -> scope, bulkList -> detailed).
const toV3OrganizationFilters = ({ isPartner, bulkList, ...filters }) => ({
  ...filters,
  ...(isPartner === true && { scope: 'to' }),
  ...(isPartner === false && { scope: 'dmc' }),
  ...(bulkList && { detailed: true }),
});

export const getOrganizations = async ({ filters = {} } = {}) => {
  const response = await getV3(
    // v3 paginates in memory with a default page size; callers that used to
    // get the whole list unpaginated need an explicit ceiling.
    `organizations?${QueryString.stringify({
      perPage: 1000,
      ...toV3OrganizationFilters(filters),
    })}`,
  );
  const unwrapped = unwrapListEnvelope(response);
  return {
    ...unwrapped,
    // Pagination consumers read the v1 count headers.
    headers: {
      ...unwrapped.headers,
      xTotalCount: `${unwrapped.meta?.total ?? unwrapped.data.length}`,
      xTotalPages: `${unwrapped.meta?.lastPage ?? 1}`,
    },
  };
};

export const updateOrganization = async (
  organizationId,
  payload,
  locale = 'en',
) => {
  return internalPut(
    `organizations/${organizationId}?locale=${locale}`,
    payload,
  );
};

// The Overview tab's figures: bookings by month, totals, connections.
export const getOrganizationOverview = ({ organizationId }) =>
  internalGet(`organizations/${organizationId}/overview`);

export const getOrganizationUsers = ({ organizationId, filters }) => {
  return internalGet(
    `organizations/${organizationId}/users?${QueryString.stringify(filters)}`,
  );
};

export const saveOrganizationCancelConditions = async ({
  organizationId,
  payload,
}) => {
  return internalPut(`organizations/${organizationId}/cancel-conditions`, {
    conditions: payload,
  });
};

export const getOrganizationCancelConditions = ({
  organizationId,
  skip = false,
}) => {
  if (!organizationId || skip) return Promise.resolve(null);

  return internalGet(`organizations/${organizationId}/cancel-conditions`);
};
